import {
  startOfWeek,
  endOfWeek,
  eachDayOfInterval,
  addWeeks,
  addDays,
  format,
  getISOWeek,
  getISOWeekYear,
  setISOWeek,
  setYear,
} from "date-fns";
import nl from "date-fns/locale/nl";

/**
 * Bereken alle datums (YYYY-MM-DD) voor een ISO-week in een jaar
 */
export function getWeekDates(year, week) {
  const firstDayOfWeek = startOfWeek(
    setISOWeek(setYear(new Date(), year), week),
    { weekStartsOn: 1 }
  );
  const lastDayOfWeek = endOfWeek(firstDayOfWeek, { weekStartsOn: 1 });

  return eachDayOfInterval({ start: firstDayOfWeek, end: lastDayOfWeek }).map(
    (d) => format(d, "yyyy-MM-dd")
  );
}

/**
 * Format YYYY-MM-DD naar Nederlands leesbaar
 * vb. "maandag 02-09-2025"
 */
export function formatDate(dateStr) {
  const d = new Date(dateStr);
  return format(d, "EEEE dd-MM-yyyy", { locale: nl });
}

/**
 * Format Date object naar NL patroon
 */
export function formatDateNL(date, pattern = "dd-MM-yyyy") {
  return format(date, pattern, { locale: nl });
}

/**
 * Bereken vorige week (ISO)
 */
export function getPrevWeek(year, week) {
  const d = setISOWeek(setYear(new Date(), year), week);
  const prev = addWeeks(d, -1);
  return { year: prev.getFullYear(), week: getISOWeek(prev) };
}

/**
 * Bereken volgende week (ISO)
 */
export function getNextWeek(year, week) {
  const d = setISOWeek(setYear(new Date(), year), week);
  const next = addWeeks(d, 1);
  return { year: next.getFullYear(), week: getISOWeek(next) };
}

/**
 * Huidige ISO-week en jaar
 */
export function getCurrentWeekYear() {
  const now = new Date();
  return { year: getISOWeekYear(now), 
    week: getISOWeek(now) };
}

/**
 * Haal ISO week-jaar op voor een datum
 */
export function getWeekYearForDate(date = new Date()) {
  return getISOWeekYear(date);
}

/**
 * Helpers: begin/eind van week ophalen + weekdagen
 */
export function getWeekStart(date = new Date()) {
  return startOfWeek(date, { weekStartsOn: 1 });
}

export function getWeekEnd(date = new Date()) {
  return endOfWeek(date, { weekStartsOn: 1 });
}

export function getWeekDays(date = new Date()) {
  return eachDayOfInterval({ start: getWeekStart(date), end: getWeekEnd(date) });
}

export function shiftWeek(date, weeks) {
  return addWeeks(date, weeks);
}

/**
 * Geef de datum voor een specifieke weekdag binnen een week
 * @param {Date} weekStart - Startdatum van de week (maandag)
 * @param {string} day - Eén van: 'monday', 'tuesday', ..., 'sunday'
 * @returns {Date}
 */
export function getDateForWeekday(weekStart, day) {
  const dayMap = {
    monday: 0,
    tuesday: 1,
    wednesday: 2,
    thursday: 3,
    friday: 4,
    saturday: 5,
    sunday: 6,
  };
  return addDays(weekStart, dayMap[day]);
}

/**
 * Geef de juiste db-key ('monday', 'tuesday', ...) voor een gegeven datum
 * @param {Date} date
 * @returns {string}
 */
export function getDbKeyForDate(date) {
  const dayIndex = date.getDay(); // 0 = zondag, 1 = maandag, ...
  const map = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
  return map[dayIndex];
}
